// extracted by mini-css-extract-plugin
export default {"p":"_42ae611b25 _236d735aa3 _0d65086076","clr":"_611bdabda2","dls":"cb83eaebbd"};